<template>
  <div>
    <h2>Printers</h2>
    <v-btn :to="{name:'printerAdd'}">
      <v-icon>add</v-icon>Printer
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="computedPrinters"
      class="elevation-1"
      v-if="computedPrinters"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <v-btn :to="{name:'printer', params:{id:props.item.id}}" small>{{ props.item.id }}</v-btn>
          </td>
          <td>
            <v-btn :to="{name:'server', params:{id:props.item.serverid}}" small>
              <span v-if="props.item.server">{{ props.item.server.name }}</span>
              <span v-if="!props.item.server">{{ props.item.serverid }}</span>
            </v-btn>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.localpath }}</td>
          <td>{{ props.item.remotepath }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
import { convertListOfObjectsToMap } from "@/util/helpers";
export default {
  name: "Printers",
  metaInfo() {
    return {
      title: "Printers",
      titleTemplate: "%s - Rest - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  computed: {
    computedPrinters() {
      if (!this.printers) {
        return undefined;
      }
      const serversMap = this.servers
        ? convertListOfObjectsToMap(this.servers, "id")
        : undefined;
      return this.printers.map(p => {
        const server = serversMap ? serversMap[p.serverid] : undefined;
        return { ...p, server };
      });
    }
  },
  data() {
    return {
      printers: null,
      servers: null,
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Server",
          value: "serverid"
        },
        {
          text: "Code",
          value: "code"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Local path",
          value: "localpath"
        },
        {
          text: "Remote path",
          value: "remotepath"
        }
      ],
      pagination: {
        rowsPerPage: -1
      }
    };
  },
  methods: {
    fetchPrinters() {
      nbmlaw.get(`/cors/admin/extras/printers`).then(response => {
        // console.log(response.data);
        this.printers = response.data;
      });
    },
    fetchServers() {
      nbmlaw.get(`/cors/admin/extras/servers`).then(response => {
        // console.log(response.data);
        this.servers = response.data;
      });
    }
  },
  created() {
    this.fetchPrinters();
    this.fetchServers();
  }
};
</script>
